module.exports = " <div class=content> <div class=\"infor b01\"> <a v-link=\"{name:'school'}\"><i>The School</i></a> </div> <div class=\"infor b02\"> <a @click=jj()><i>The World</i></a> </div> <div class=\"infor b03\"> <a href=http://gotit.asia/cet><i>CET - 4 / 6</i></a> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.4/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information.vue
 ** module id = 17
 ** module chunks = 1
 **/